/* Momeaze — product card "add to cart" button.
   Replaces the inline onclick that used to live in card-product.liquid, which
   POSTed to /cart/add.js and hand-incremented the count bubble without ever
   opening the cart drawer. Delegated so it also covers cards injected later by
   facet filtering / pagination / quick-add re-renders. */
(function () {
  'use strict';
  if (window.MzCardActions) return;

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function bumpBubble(delta) {
    var el = document.querySelector('.cart-count-bubble span[aria-hidden]');
    if (el) el.textContent = String((parseInt(el.textContent, 10) || 0) + delta);
  }

  function flash(btn, message) {
    var t = document.querySelector('.mz-card-toast');
    if (t) t.remove();
    t = document.createElement('div');
    t.className = 'mz-card-toast';
    t.textContent = message;
    document.body.appendChild(t);
    requestAnimationFrame(function () {
      t.classList.add('show');
    });
    setTimeout(function () {
      t.classList.remove('show');
      setTimeout(function () {
        t.remove();
      }, 300);
    }, 2600);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mz-card-cart');
    if (!btn) return;

    // The card is fully covered by Dawn's title-link overlay; stop the click
    // from reaching it so we don't navigate away mid-add.
    e.preventDefault();
    e.stopPropagation();

    var variantId = parseInt(btn.dataset.variant, 10);
    if (!variantId || btn.disabled) return;

    var cd = drawer();
    var body = {
      items: [{ id: variantId, quantity: 1 }],
    };
    // Ask Shopify to re-render the drawer + bubble in the same round trip so
    // renderContents() has real HTML to swap in.
    if (cd && typeof cd.getSectionsToRender === 'function') {
      body.sections = cd.getSectionsToRender().map(function (s) {
        return s.id;
      });
      body.sections_url = window.location.pathname;
    }

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          // 422 = sold out / exceeds stock. res.data.description is merchant-facing copy.
          flash(btn, res.data.description || res.data.message || 'Could not add to cart');
          return;
        }
        if (cd && typeof cd.renderContents === 'function' && res.data.sections) {
          cd.renderContents(res.data); // re-renders drawer + bubble, then opens
        } else {
          bumpBubble(1);
          flash(btn, 'Added to cart');
        }
      })
      .catch(function () {
        flash(btn, 'Could not add to cart');
      })
      .finally(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      });
  });

  window.MzCardActions = true;
})();
